import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=4836f0d8&scoped=true"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=4836f0d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836f0d8",
  null
  
)

export default component.exports